import React from 'react';
import styled from 'styled-components';
import { array } from 'prop-types';

const HighlightBox = styled.span`
  height: 18px;
  background-color: #9027B0;
  color: #FFF;
  border-radius: 4px;
  padding: 0px 5px;
  margin-left: 5px;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
`;

const VisualHighlight = ({ children }) => (
  <HighlightBox>
    {children}
  </HighlightBox>
);

VisualHighlight.propTypes = {
  children: array.isRequired,
};

export default VisualHighlight;
